import React from "react";

export default function EditBottomComponent({ saveButton, disable }) {
  return (
    <div style={{ marginBottom: 5 }} className="mt-4 text-right">
      <div className="col-lg-12">
        <div className="form-group mb-0">
          <button
            disabled={disable}
            style={{ marginRight: 10 }}
            data-dismiss="modal"
            type="submit"
            id="tests"
            defaultValue="Post Comment"
            className="submit btn btn-primary"
            name="submit"
            onClick={saveButton}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
}
